import React from "react";
import './top-navigation-bar.styles.css'

export default function TopNavigationBar() {
    return (
        <div id="main_menu" className="ui top fixed menu cctech-top-navbar-background">
            <div className="top-bar hide-on-mobile hide-on-tablet">
                <div className="ui container">
                    <a href="https://experiments-dev.cctech.co.in" className="item" id="tnbLogoHeaderLink">
                        <h3 className="ui header">
                            <img id="tnbLogoHeaderImage" src="https://static.cctech.co.in/prod/images/common/cctech-logo/CCTech-Research-Logo-Header.svg" alt="Logo Header"></img>
                        </h3>
                    </a>
                    <div className="right menu cctech-top-navbar">
                        <a target="_blank" rel="noreferrer" href="mailto:info@cctech.co.in" className="item" id="tnbInfoLink">
                            <span className="menu-text"><i className="fa fa-lg fa-at text blue" id="tnbInfoText"></i>info@cctech.co.in</span>
                        </a>
                        <div className="item" id="tnbContactUsDiv">
                            <a href="https://www.cctech.co.in/contact-us#send-a-message">
                                <div className="svg-button svg-blue-button" id="tnbContactUsSubDiv">
                                    <svg height="40" width="160" xmlns="http://www.w3.org/2000/svg">
                                        <rect height="100%" width="100%" className="svg-button-background"></rect>
                                        <g>
                                            <text className="svg-button-text" x="20" y="65%">Send a Message</text>
                                        </g>
                                    </svg>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ui container">
                <a id="min_button" className="toc item" href="null.com">
                    <i className="fa fa-bars fa-lg"></i>
                </a>
                <div className="right menu" id="min_div">
                    <a href="https://experiments-dev.cctech.co.in" className="item" id="min_logo">
                        <h3 className="ui header">
                            <img id="min_logoImage" src="https://static.cctech.co.in/prod/images/common/cctech-logo/CCTech-Research-Logo-Header-Collapsed.svg" alt="Logo Header Collapsed"></img>
                        </h3>
                    </a>
                </div>
                <a href="https://experiments-dev.cctech.co.in" className="item page-scrolled-logo" id="tnbResearchLogoHeaderLink">
                    <h3 className="ui header">
                        <img id="tnbResearchLogoHeaderImage" src="https://static.cctech.co.in/prod/images/common/cctech-logo/CCTech-Research-Logo-Header.svg" alt="Research Logo Header"></img>
                    </h3>
                </a>
                <div className="right menu cctech-top-navbar">
                    <a href="https://www.cctech.co.in/research#areas" className="item research-areas">
                        <span className="menu-text">Research areas</span>
                    </a>
                    <a href="https://experiments-dev.cctech.co.in" className="item research-project">
                        <span className="menu-text">Projects</span>
                    </a>
                    {/* <a href="https://www.cctech.co.in/research/research-people" className="item research-people">
                        <span className="menu-text">People</span>
                    </a> */}
                    <a href="https://www.cctech.co.in/careers" className="item resarch-careers">
                        <span className="menu-text">Careers</span>
                    </a>
                    {/* <a href="https://www.cctech.co.in/blog/category/Research" className="item resarch-blog">
                        <span className="menu-text">Blog</span>
                    </a> */}
                </div>
            </div>
        </div>
    )
}